import { EnumHelperBase, type EnumDataObject } from './enum.helpers';

export enum REQ_SOURCE {
	WEB = 1,
	MOBILE_ANDROID = 2,
	MOBILE_IOS = 3,
	WEB_UNITED_TICKETS = 4,
	WEB_DINO_LIVE = 5,
	GOOUT = 6,
	EASOL = 7,
	SHERWOOD = 8,
}

export interface ReqSourceEnumBaseData extends EnumDataObject<ReqSourceEnumBaseExtraData, REQ_SOURCE, 'reqSourceId'> {}

export interface ReqSourceEnumBaseExtraData {}

/**
 * Base ReqSource enumeration class
 * @see https://github.com/NFCtron/nfctron-db/blob/dev/diagrams/global.png
 */
class ReqSourceEnumBase extends EnumHelperBase<ReqSourceEnumBaseExtraData, REQ_SOURCE, 'reqSource', 'reqSourceId'> {
	constructor() {
		super(
			'reqSource',
			{
				[REQ_SOURCE.WEB]: {},
				[REQ_SOURCE.MOBILE_ANDROID]: {},
				[REQ_SOURCE.MOBILE_IOS]: {},
				[REQ_SOURCE.WEB_UNITED_TICKETS]: {},
				[REQ_SOURCE.WEB_DINO_LIVE]: {},
				[REQ_SOURCE.GOOUT]: {},
				[REQ_SOURCE.EASOL]: {},
				[REQ_SOURCE.SHERWOOD]: {},
			},
			'reqSourceId',
			null,
		);
	}
}

export const reqSourceEnumBase = new ReqSourceEnumBase();
